/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
// eslint-disable-next-line no-unused-vars
import { node, jsxWatch } from "venuescanner-js/tools/jsx";
import service from "./service";
import { Attachment } from "./Attachment";
import { FileDrop } from "./fileDrop";
import { ObservableArray } from "venuescanner-js/vanilla/models/ObservableArray";
import {
  BOOLEAN,
  STRING,
  INTEGER,
} from "venuescanner-js/vanilla/models/ObservablePropTypes";
import { ArrayComponents } from "venuescanner-js/vanilla/components/observable/arrayJsx";
// import { ArrayCount } from 'venuescanner-js/vanilla/components/observable/arrayCount'
const attachmentSchema = {
  icon: STRING,
  filename: STRING,
  _id: STRING,
  path: STRING,
  url: STRING,
  size: INTEGER,
  checked: BOOLEAN,
};

const AttachButton = ({ attachMessage, cantSelect }) => {
  return (
    <vs-btn type="primary" disabled={cantSelect}>
      {attachMessage}
    </vs-btn>
  );
};

export const Library = ({
  library,
  whenAttached = () => {},
  isMobileDevice,
}) => {
  const { attachments } = library;
  const isVenueLibrary = !!library.venue;
  const selected = new ObservableArray(null, { schema: attachmentSchema });
  const attachMessage = new STRING(null, "No files selected");
  const cantSelect = new BOOLEAN(null, true);
  const attachmentArr = new ObservableArray(null, {
    schema: attachmentSchema,
    props: attachments.map((arr) => {
      return {
        ...arr,
        checked: false,
      };
    }),
  });
  attachmentArr.watch(() => {
    selected.set(
      JSON.parse(
        JSON.stringify(
          attachmentArr.filter((attachment) => attachment.checked.valueOf())
        )
      )
    );
    // console.log(JSON.parse(JSON.stringify(selected)))
    attachMessage.set(
      selected.length
        ? `Attach ${selected.length} file${selected.length !== 1 ? "s" : ""}`
        : "No files selected"
    );
    cantSelect.set(selected.length === 0);
  });
  const removeItem = async (item) => {
    document.getElementById("fileElemForm").reset();
    return service.removeAttachment(library.venue, item.path.valueOf());
  };
  return (
    <div class="attachment-library">
      <h3 class="attachment-library__title">
        {isVenueLibrary ? "Venue" : "Your"} Attachments
      </h3>
      <FileDrop
        venue={library.venue}
        filelist={attachmentArr}
        isMobileDevice={isMobileDevice}
      />
      <div class="attachment-library-files">
        {ArrayComponents(attachmentArr, (attachment, ref) => (
          <Attachment
            ref={ref}
            attachment={attachment}
            removeItem={removeItem}
          />
        ))}
      </div>
      <div class="attachment-library-button-area">
        <AttachButton
          attachMessage={attachMessage}
          cantSelect={cantSelect}
          onClick={() => {
            whenAttached(selected);
          }}
        />
      </div>
    </div>
  );
};
